import React, { useEffect } from 'react';

import cn from 'classnames';
import { useDispatch, useSelector } from 'react-redux';

import MiniPlayer from 'components/MiniPlayer';
import AddStoryToPlaylist from 'components/Playlists/AddStoryToPlaylist';
import CreatePlaylist from 'components/Playlists/CreatePlaylist';
import TabBar from 'components/TabBar';

import CoursePlayer from 'containers/AudioCourse/CoursePlayer';
import FullWidthContainer from 'containers/FullWidthContainer';
import Player from 'containers/StoryDetails/Player';

import { usePlayer } from 'hooks/usePlayer';

import { setWithTabBar } from 'store/modules/appSettings';
import {
  getIsAddStoryToPlaylistOpen,
  getIsPlaylistCreationOpen,
} from 'store/modules/playlist';
import ReduxState from 'store/ReduxState';

interface IProps {
  className?: string;
  disableMiniPlayerPadding?: boolean;
  withTabBar?: boolean;
  tabBarClassName?: string;
  children: React.ReactNode | React.ReactNode[];
}

const PageContainer = ({
  children,
  className,
  disableMiniPlayerPadding,
  withTabBar = true,
  tabBarClassName,
}: IProps) => {
  const renderFullPlayer = useSelector<ReduxState, boolean>(
    ({ player }) => player.fullPlayer,
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setWithTabBar(withTabBar));
  }, [dispatch, withTabBar]);

  const isPlaylistCreationOpen = useSelector(getIsPlaylistCreationOpen);
  const isAddStoryToPlaylistOpen = useSelector(getIsAddStoryToPlaylistOpen);

  const { currentlyPlaying } = usePlayer();
  const storyId = currentlyPlaying && currentlyPlaying.id;

  return (
    <FullWidthContainer className={className}>
      <div
        className={cn('FullWidthContainer__wrapper', {
          'miniPlayer-opened': currentlyPlaying,
          'remove-padding-bottom': disableMiniPlayerPadding,
          'with-tab-bar': withTabBar,
        })}
      >
        {children}
      </div>
      {renderFullPlayer && storyId && <Player storyId={storyId} />}

      <MiniPlayer fixedToScreenBottom={!withTabBar} />
      <CoursePlayer fixedToScreenBottom={!withTabBar} />
      {withTabBar && <TabBar className={tabBarClassName} />}
      {isPlaylistCreationOpen && <CreatePlaylist />}
      {isAddStoryToPlaylistOpen && <AddStoryToPlaylist />}
    </FullWidthContainer>
  );
};

export default PageContainer;
